import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import styled from 'styled-components'
import InputGroup from './InputGroup'
import eyeOpened from '@icons/eye/opened'
import eyeOpenedActive from '@icons/eye/opened-active'
import eyeClosed from '@icons/eye/closed'
import eyeClosedActive from '@icons/eye/closed-active'

const iconMapping = {
  default: {
    true: eyeClosed,
    false: eyeOpened
  },
  active: {
    true: eyeClosedActive,
    false: eyeOpenedActive
  }
}

const Toggler = styled.button`
  position: absolute;
  right: 2px;
  top: 2px;
  bottom: 2px;
  width: 40px;
  border: 0;
  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url(${props => iconMapping.default[props.isHidden]});
  user-select: none;
  &:hover {
    outline: none;
    background-image: url(${props => iconMapping.active[props.isHidden]});
  }
`

class PasswordInput extends Component {
  constructor(props) {
    super(props)
    this.state = { hidden: true }
    this.toggle = this.toggle.bind(this)
    this.renderComponent = this.renderComponent.bind(this)
  }

  toggle(_) {
    this.setState({ hidden: !this.state.hidden })
  }

  renderComponent(forwardedProps) {
    const { toggleEnabled } = this.props
    const { hidden } = this.state

    const inputClasses = classnames(
      'text-input',
      {
        'text-input--append--inset': !!toggleEnabled
      }
    );

    return (
      <Fragment>
        <input
          className={inputClasses}
          type={hidden ? "password" : "text"}
          {...forwardedProps}
        />

        { toggleEnabled ? (
            <Toggler type="button" onClick={this.toggle} isHidden={hidden} />
          ) : null
        }
      </Fragment>
    )
  }

  render() {
    const { toggleEnabled, ...rest } = this.props
    return (
      <InputGroup {...rest} Component={this.renderComponent} />
    )
  }
}

PasswordInput.defaultProps = {
  toggleEnabled: true
}

export default PasswordInput
